import axios from "axios";
import singletonSession from "./IntanceSession";
import singletonMysqlApis from "./IntanceMysqlApis";

const initSession = async () => {
    try {
        let username = 'admin';
        let password = 'admin';
        let credentials = btoa(username + ':' + password);

        const config = {
            method: 'post',
            url: `${process.env.REACT_APP_HOST_APIS}:${process.env.REACT_APP_PORT_SESSION}/api/login`,
            headers: {
                'Authorization': 'Basic ' + credentials
            }
        };

        await axios(config);

        const resp = await singletonSession
            .getInstance()
            .post("/users/client");

        const token = resp.data.AccesToken;

        window.localStorage.setItem('session', token);
        singletonMysqlApis.setToken(token);

        return true;

    } catch (error) {
        console.error("Error inicializando sesión:", error);
        throw error; // evita renderizar App si falla
    }
};

export {
    initSession
};
